module.exports = __webpack_public_path__ + "static/media/authorizedVC.b301be15.svg";